import { DOOR_TYPE } from '../../types/door-type.js';
import { RG_TYPE } from '../../types/rg-type.js';

const DefaultDoor = {
    type: RG_TYPE.Door,
    modulousId: 'DIS|02|UK-DIS0002',
    size: [0.5, 0.8, 0.11],
    anchor: [0.5, 0, 0.5],
    name: 'door',
    children: [],
    color: '#564C83',
    data: {
        doorType: DOOR_TYPE.Misc
    }
};

export { DefaultDoor };
//# sourceMappingURL=default-door.js.map
